import React, { useEffect, useState } from "react";

import { getPaymentHistory } from "../../../services/payment/payment";
import PaymentHistoryCard from "./PaymentHistoryCard";
import Pagination from "../../common/Pagination";
import { config, SlamaRequestTypes } from "../../../utils/constants";

import { ServiceTranslation } from "../../../utils/constants";
import { fetchTranslationData } from "../../../services/translation/translation";
import { getUserDetails } from "../../../services/epic/medicalReport";
import { capitalizeWords, configureFirstIframe, getCurrentLocale, getLayoutDirection } from "../../../utils/util";


const PaymentHistory = ({ salamaRequestType }) => {
  const [paymentHistory, setPaymentHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [translationMap, setTranslationMap] = useState(null);
  const [totalPayment, setTotalPayment] = useState("");
  const [patientName, setPatientName] = useState("");
  const pageSize = 10;

  const loadPaymentHistory = (page) => {
    setLoading(true);
    getPaymentHistory(page, pageSize, salamaRequestType)
    .then((response) => {
      window.parent.scrollTo(0, 0);

      if (response.data.items && response.data.items.length > 0) {
        setPaymentHistory(response.data.items);
        setTotalPages(response.data.lastPage || 1);
        setTotalPayment(response.data.totalCount || 1);
      } else {
        setPaymentHistory([]);
      }
      setLoading(false);
    })
    .catch(() => {
      setLoading(false);

    });
  };

  const setPatientFullName = () => {
    setLoading(true);
    getUserDetails().then((result) => {
      let { PatientFirstName, patientLastName, patientArabicLastName, patientArabicFirstName } = result.data;
      let firstName = PatientFirstName;
      let lastName = patientLastName;

      if (getCurrentLocale() === "ar" && patientArabicFirstName && patientArabicLastName) {
        firstName = patientArabicFirstName;
        lastName = patientArabicLastName;
      }
      setPatientName(`${firstName} ${lastName}`);
      setLoading(false);
    });


  };

  useEffect(() => {
    loadPaymentHistory(currentPage);
    setPatientFullName();
    configureFirstIframe(200, 2300, true);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, salamaRequestType]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  useEffect(() => {
    fetchTranslationData(ServiceTranslation.Payment).then((result) => {
      setTranslationMap(result);
    });
  }, []);

  let backUrl = "";
  let serviceName = "";
  let paymentHistoryServiceName = "";
  if (salamaRequestType === SlamaRequestTypes.sickLeaveApplication) {
    backUrl = config.slaBackUrl;
    serviceName = translationMap?.sickLeaveServiceName;
    paymentHistoryServiceName = translationMap?.sickLeave;
  } else if (salamaRequestType === SlamaRequestTypes.medicalReportRequest) {
    backUrl = config.mrBackUrl;
    serviceName = translationMap?.mrServiceName;
    paymentHistoryServiceName = translationMap?.medicalReport;
  } else if (salamaRequestType === SlamaRequestTypes.healthCardRenewal) {
    backUrl = config.hcrBackUrl;
    serviceName = translationMap?.hrcServiceName;
    paymentHistoryServiceName = translationMap?.renewHealth;
  }


  if (loading) return <div>{translationMap?.loading || "Loading..."}</div>;

  return (
    <div className={` custombody_color ${getLayoutDirection()}`}>
            <section
        className="w-100 clearfix RenewCoveragePlanSection PaymentHistoryListBx"
        id="CoverPlanActive">
        
                <div className="container customContainer">
                    <div className="Title_Inner_Box">
                        <h6 className="MainTitleOne"> {paymentHistoryServiceName} {" "} {translationMap?.paymentHistory}</h6>
                    </div>
                    <div className="cover_inner_wrapper">
                        <div className="cover_main_box1">
                            {paymentHistory.length === 0 ?
              <div class="AlertInnerBox YellowAlertInnerBox alert alert-dismissible">

                                    <div class="Icon_box">
                                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                                        <a href="javascript:void(0);">
                                <span class="material-symbols-outlined">
                                    info
                                </span>
                                        </a>
                                    </div>
                                    <div class="alert_text">
                                        <h6>
                                            <p>
                                                {translationMap?.no_payment_history}
                                            </p>
                                        </h6>
                                        <p class="number_txt">
                                            {""}
                                        </p>
                                    </div>
                                </div> :

              <>
                                    <p className="History_title">
                                        {translationMap?.showing} {totalPayment} {translationMap?.results_for} {" "}
                                        <span>
                                            {capitalizeWords(patientName)}.
                                        </span>
                                    </p>
                                    <div className="payment_status_wrap">
                                        {paymentHistory.length === 0 ?
                  <p>{translationMap?.no_records_found}</p> :

                  paymentHistory.map((payment, index) => {
                    return (
                      <PaymentHistoryCard
                        key={index}
                        amount={payment.amount}
                        status={payment.paymentStatus}
                        date={payment.dateCreated}
                        refno={payment.sptrn}
                        salmaRequestNo={payment.salamaRequestReqNumber}
                        translationMap={translationMap} />);


                  })
                  }
                                    </div>
                                    {paymentHistory.length > 0 && totalPayment > 8 &&
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                  translationMap={translationMap} />


                }
                                </>
              }


                            <button className="payment_main_btn_box">
                                <a className="bluetrans_btn_link" href={backUrl}>
                                    {translationMap?.back_to} {serviceName}
                                </a>
                            </button>
                        </div>
                        <div className="cover_main_box2"></div>
                    </div>
                </div>
            </section>
        </div>);

};

export default PaymentHistory;